import React, { useEffect, useState } from "react";
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import Modal from "react-bootstrap/Modal";
import nest from "../../../services/nest";
import Loading from "../../../components/Loading";
import { getUserId } from "../../../services/auth";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function ModalEditarPerfilMaster({
  mostrar,
  handleClose,
  setAlerta,
  handleOpenModalSenha,
  userMaster,
  loadOutrosUsuariosAbaixo
}) {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [form, setForm] = useState({
    nome:  "",
    email: "",
    senha: "",
  });
  useEffect(() => {
    if (mostrar && userMaster) {
      setForm({
        nome: userMaster.nome || '',
        email: userMaster.email || '',
        senha: "",
      });
    }
  }, [mostrar, userMaster]);
  useEffect(() => {
    if (form.email !== userMaster.email) {
      setShowConfirmPassword(true);
    } else {
      setShowConfirmPassword(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.email]);
  const handleValidEmail = () => {
    setForm({ ...form, email: form.email.trim() });
    let reg =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (form.email !== "" && form.email != null) {
      if (reg.test(form.email) === false) {
        setAlerta({
          status: true,
          msg: "O e-mail não é valido!",
          type: "error",
        });
        return false;
      } else if (reg.test(form.email) === true) {
        return true;
      }
    }
  };
  const atualizazrUsuarioMaster = async () => {
    if (!form.nome || form.nome.length < 3) {
      setAlerta({
        status: true,
        msg: "Nome deve ter pelo menos 3 caracteres!",
        type: "error",
      });
      return false;
    }
    if (!form.email) {
      setAlerta({
        status: true,
        msg: "Preencha o e-mail!",
        type: "error",
      });
      return false;
    }
    if (!handleValidEmail()) {
      setAlerta({
        status: true,
        msg: "O e-mail não é valido!",
        type: "error",
      });
      return false;
    }

    let clienteUsuarioId = await getUserId();
    setLoading(true);
    const data = {
      nome: form.nome,
      email: form.email,
      data_nascimento: null,
    };
    nest
      .put("/cliente/cliente-usuarios/atualizarDadosPessoais", data, {
        params: {
          clienteUsuarioId: clienteUsuarioId,
          senha: form.senha,
        },
      })
      .then(function (response) {
        setLoading(false);
        handleClose();
        loadOutrosUsuariosAbaixo();
      })
      .catch(function (error) {
        setAlerta({
          status: true,
          msg: error.response?.data?.message || "Erro ao atualizar!",
          type: 'error'
        })
        console.log(error);
        setLoading(false);
      });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  return (
    <Modal show={mostrar} onHide={handleClose} centered>
      <Loading open={loading} />
      <Modal.Header closeButton style={{ paddingTop: 10, paddingBottom: 10 }}>
        <Modal.Title
          style={{
            color: "var(--main-bg-color)",
            width: "100%",
            textAlign: "center",
          }}
        >
          Editar Perfil Master
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginLeft: 50, marginRight: 50, marginTop: 0 }}>
          <FormControl sx={{ m: 1, width: "100%" }} variant="outlined">
            <InputLabel>Nome</InputLabel>
            <OutlinedInput
              type="text"
              value={form.nome}
              onChange={(e) => setForm({ ...form, nome: e.target.value })}
              label="Nome"
            />
          </FormControl>
          <FormControl sx={{ m: 1, width: "100%" }} variant="outlined">
            <InputLabel>E-mail</InputLabel>
            <OutlinedInput
              label="E-mail"
              value={form.email}
              type="email"
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </FormControl>
          {showConfirmPassword && (
            <FormControl sx={{ m: 1, width: "100%" }} variant="outlined">
              <InputLabel>Confirme a senha</InputLabel>
              <OutlinedInput
                type={showPassword ? "text" : "password"}
                value={form.senha}
                onChange={(e) => setForm({ ...form, senha: e.target.value })}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Senha"
              />
            </FormControl>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div onClick={() => handleClose()}>
          <Button style={{ backgroundColor: "#a3a3a3" }} variant="contained">
            Cancelar
          </Button>
        </div>
        <div onClick={() => handleOpenModalSenha()}>
          <Button
            style={{ backgroundColor: "var(--main-bg-color)" }}
            variant="contained"
          >
            Alterar Senha
          </Button>
        </div>
        <div onClick={() => atualizazrUsuarioMaster()}>
          <Button
            style={{ backgroundColor: "var(--main-bg-color)" }}
            variant="contained"
            disabled={loading}
          >
            Atualizar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalEditarPerfilMaster;
